<template>
  <div class="shadow-fixed show">
    <div class="mask"></div>
    <div class="bomb-com-box full-bomb">
      <div class="bomb-small-close" @click="closeLargePic"></div>
      <div class="qe-view-detail">
        <div class="cp-column cp-bomb-full cp-swiper">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item,index) in currentImgList" :key="index">
              <img :src="item" />
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  data() {
    return {
      swiperOption: {
        initialSlide: 0,
        simulateTouch: false,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
    }
  },
  components:{
    swiper,
    swiperSlide
  },
  props:{
    currentImgList:{
      type:Array,
      required:true
    },
    activeIndex:{
      type:Number,
      required:true
    }
  },
  methods:{
    closeLargePic(){
      this.$emit('closeLargePic');
    }
  },
  created(){
    this.swiperOption.initialSlide = this.activeIndex;
  }
}
</script>

<style>
  .swiper-container{
    width:100%;
    height:100%;
  }
</style>